"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.status.pending': 'Pendiente',
    'payment.status.success': 'Éxito',
    'payment.status.rejected': 'Rechazado',
    'payment.status.error': 'Error',
    'payment.status.unknown': 'Desconocido',
};
